module.exports = __webpack_public_path__ + "assets/media/s32.481d02e9.mp3";